import { api } from "@/api"

type requestPasswordResetMerchantGroupIn = {
  email: string
}

export const requestMerchantGroupAdminPasswordReset =
  async (params: requestPasswordResetMerchantGroupIn) => {
    const { body } = await api.post<{ message: string }>(
      "/merchant-group/request-password-reset/",
      { body: params }
    )
    return body
  }
